// AI Generated Test
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { PolicyHelperService } from '@client/app/blocks/helpers/policy-helper/policy.helper.service';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { PageService } from '@client/app/services/entities/page/page.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PolicyService } from '@client/app/services/entities/policy/policy.service';

@Component({
    selector: 'page-details-policy-information',
    standalone: false,
    template: `
        <div class="bg-light-grey page-details-information-site information-shadow page-details-policy-information max-height">
            <div class="row">
                <div class="col-48" *ngIf="policy.id">
                    <div class="row border-bottom py-4 px-3">
                        <div class="col-lg-4">
                            <mon-table-policy-type class="inline-block"
                                                   [passed]="policy.matches_count === 0 && policy.state !== 'running'"
                                                   [target]="getPolicyTarget(policy)">
                            </mon-table-policy-type>
                        </div>
                        <div class="col-lg-44">
                            <div class="side-panel-header">
                                {{ policy.name }}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-48 border-bottom">
                        <page-details-sections-tabs [tab]="tab" [options]="tabOptions">
                            <div class="py-1">
                                <mon-action-menu [monActionMenuItems]="dropdownOptions"
                                                 *ngIf="policy.matches_count > 0 || policy.state !== 'running'">
                                    <span translate>Action</span>
                                </mon-action-menu>
                                <mon-extension-visual-link-button [page]="page"
                                                              [type]="'pol'"
                                                              [data]="policy"
                                                              [monDisabled]="policy.matches_count === 0"
                                                              class="pl-1">
                                </mon-extension-visual-link-button>
                            </div>
                        </page-details-sections-tabs>
                    </div>
                    <div class="col-lg-48">
                        <ul class="list-unstyled">
                            <li class="outer-t">
                                <span class="text-grey fas fa-info-circle"></span>
                                <span class="text-grey" translate>Created</span>
                                <span>{{ policy.created_at | userDate }}</span>
                            </li>
                            <li class="outer-t-smurf">
                                <span class="text-grey fas fa-clock"></span>
                                <span class="text-grey" translate>Last run</span>
                                <span>{{ getLastRunAt() }}</span>
                            </li>
                            <li *ngIf="policy.scheduled" class="outer-t-smurf">
                                <span class="text-grey fas fa-clock"></span>
                                <span class="text-grey" translate>This policy is scheduled</span>
                            </li>
                            <li *ngIf="policy.violation" class="outer-t-smurf">
                                <span class="text-grey fas fa-bug text-danger"></span>
                                <span class="text-grey" translate>(This policy is marked as unwanted content)</span>
                            </li>
                        </ul>

                        <div class="card outer-t">
                            <div class="card-header inner-b-none">
                                <div class="font-weight-300 font-size-1-3">
                                    <span class="fas fa-comment"></span>
                                    <span translate>Policy note</span>
                                </div>
                            </div>
                            <div class="card-body">
                                <span class="text-grey text-center" *ngIf="!policy.note" translate>No note has been added</span>
                                {{ policy.note }}
                            </div>
                        </div>
                    </div>
                    <div class="col-48 matches">
                        <ng-container *ngFor="let match of policy.matches; let i = index; trackBy: trackByIndex">
                            <div class="alert alert-info"
                                 [ngClass]="{'outer-t-small': i > 0}"
                                 *ngIf="match.matches.length > 0">
                                <div class="row">
                                    <div class="col-48">
                                        <span *ngFor="let icon of elements[findIndexOfElement(match.type)].icons; trackBy: trackByIndex"
                                              [class]="icon + ' icons outer-r-mini inline-block'"></span>
                                        {{match.name}}
                                    </div>
                                </div>

                                <div class="clearfix"></div>

                                <page-details-policy-information-image [model]="match"
                                                                       *ngIf="isMatchAnImage(match)">
                                </page-details-policy-information-image>

                                <ul class="list-unstyled" *ngIf="isMatchALink(match) && !isMatchAnImage(match)">
                                    <!-- TODO: Implement loadMoreMatches here when this li is in view -->
                                    <li class="text-ellipsis"
                                        *ngFor="let subMatch of match.matches | slice:0:matchLimit; let j = index; trackBy: trackByIndex">
                                        <a [href]="subMatch"
                                           [attr.alt]="'go to the matched link' | translate"
                                           target="_blank"
                                           aria-describedby="linkOpensInNewTab">{{subMatch}}</a>
                                    </li>
                                </ul>

                                <ul class="list-unstyled" *ngIf="!isMatchALink(match) && !isMatchAnImage(match)">
                                    <!-- TODO: Implement loadMoreMatches here when this li is in view -->
                                    <li class="text-ellipsis"
                                        *ngFor="let subMatch of match.matches | slice:0:matchLimit; let j = index; trackBy: trackByIndex">
                                        <span>{{subMatch}}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                        <br>
                        <ng-container *ngFor="let match of policy.matches; let i = index; trackBy: trackByIndex">
                            <div class="alert alert-info"
                                 [ngClass]="{'outer-t-small': i > 0}"
                                 *ngIf="match.matches.length === 0">
                                <div class="row">
                                    <div class="col-48">
                                        <span *ngFor="let icon of elements[findIndexOfElement(match.type)].icons; trackBy: trackByIndex"
                                              [class]="icon + ' icons outer-r-mini inline-block'"></span>
                                              {{match.name}}
                                              <br>
                                        <span translate>This rule doesn't contain any matches</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsPolicyInformationComponent implements OnInit, OnChanges {
    @Input() policy: any = {};
    @Input() refreshPolicies!: () => void;
    @Input() page: any;
    @Input() matchLimit: number = 0;

    tab: string = '';
    tabOptions: any[] = [];
    dropdownOptions: any[] = [];
    domain: any;
    elements: any[] = [];

    constructor (
        private translateService: TranslateService,
        private sessionService: SessionService,
        private policyService: PolicyService,
        private pipeService: PipeService,
        private policyHelperService: PolicyHelperService,
        private policyFormHelperService: PolicyFormHelperService,
        private monModalService: MonModalService,
        private pageService: PageService,
        private monEventService: MonEventService,
    ) {}

    ngOnInit (): void {
        this.setupTabs();
        this.policy = {};
        this.domain = this.sessionService.domain;
    }

    ngOnChanges (): void {
        if (!this.policy) {
            return;
        }
        this.getElements();
        this.updateDropdown();
    }

    private updateDropdown (): void {
        const dropdown = [
            {
                label: this.translateService.getString('Run policy again'),
                leftIcon: 'faPlay',
                action: () => this.runPolicy(),
                eventParams: { action: 'page-details-policies-return' },
                shouldShow: this.policy.state !== 'running' && this.policy.state !== 'queued',
            },
            {
                label: this.translateService.getString('Policy in queue'),
                leftIcon: 'faPlay',
                shouldShow: this.policy.state === 'queued',
                disabled: true,
            },
            {
                label: this.translateService.getString('Unignore'),
                leftIcon: 'faEye',
                action: () => this.updatePolicyStatus(false),
                eventParams: { action: 'page-details-policies-unignore' },
                shouldShow: this.policy.matches_count > 0 && this.policy.ignored,
            },
            {
                label: this.translateService.getString('Ignore'),
                leftIcon: 'faEyeSlash',
                action: () => this.updatePolicyStatus(true),
                eventParams: { action: 'page-details-policies-ignore' },
                shouldShow: this.policy.matches_count > 0 && !this.policy.ignored,
            },
            {
                label: this.translateService.getString('Mark as fixed'),
                leftIcon: 'faCheck',
                action: () => this.deletePolicy(),
                eventParams: { action: 'page-details-policies-mark-fixed' },
                shouldShow: this.policy.matches_count > 0 && !this.policy.ignored,
            },
        ];

        this.dropdownOptions = dropdown.filter((option) => option.shouldShow !== false).map(item => {
            return {
                label: item.label,
                leftIcon: item.leftIcon,
                disabled: item.disabled,
                action: () => {
                    if (item.eventParams) {
                        this.monEventService.run('actionTrigger', item.eventParams);
                    }

                    if (item.action) {
                        item.action();
                    }
                },
            };
        });
    }

    private setupTabs (): void {
        this.tabOptions = [
            {
                name: this.translateService.getString('Information'),
                value: 'information',
            },
        ];

        this.tab = this.tabOptions[0].value;
    }

    runPolicy (): void {
        this.monModalService
            .confirm(
                this.translateService.getString('Are you sure you want to run the policy <strong>[[policyName]]</strong> again?', {
                    policyName: this.policy.name,
                }),
            )
            .then(() => {
                this.policyService.run(this.policy.id).then(() => {
                    setTimeout(() => {
                        this.refreshPolicies();
                    }, 50);
                }, () => {});
            }, () => {});
    }

    updatePolicyStatus (status: boolean): void {
        let message: string;
        if (status) {
            message = this.translateService.getString('Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?', {
                policyName: this.policy.name,
            });
        } else {
            message = this.translateService.getString('Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?', {
                policyName: this.policy.name,
            });
        }
        this.monModalService.confirm(message).then(() => {
            const model = {
                id: this.policy.id,
                ignored: status,
            };

            this.pageService.updatePolicy(this.page.id, model).then(() => {
                this.refreshPolicies();
            }, () => {});
        }, () => {});
    }

    deletePolicy (): void {
        this.monModalService
            .confirm(
                this.translateService.getString('Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?', {
                    policyName: this.policy.name,
                }),
            )
            .then(() => {
                this.pageService.destroyPolicy(this.page.id, this.policy.id).then(() => {
                    this.refreshPolicies();
                }, () => {});
            }, () => {});
    }

    getPolicyTarget (policy: any): any {
        return this.policyHelperService.getType(policy);
    }

    getLastRunAt (): string {
        if (this.policy.constructor === Object && Object.keys(this.policy).length > 0) {
            const domainTarget = this.policy.targets.find((domain: any) => {
                return this.domain.id === domain.id;
            });
            if (domainTarget && domainTarget.latest_run_at !== null) {
                return this.pipeService.get('userDate')(domainTarget.latest_run_at);
            } else {
                return this.translateService.getString('Never');
            }
        }
        return '';
    }

    private getElements (): void {
        this.policyFormHelperService.setPolicySubject(this.policy?.subject || '');
        this.elements = this.policyFormHelperService.getSubjectTypeOptions();
    }

    findIndexOfElement (ruleType: string): number {
        let result = -1;
        for (let i = 0; i < this.elements.length; i++) {
            if (this.elements[i].type === ruleType) {
                result = i;
                break;
            }
        }
        return result;
    }

    isMatchALink (match: any): boolean {
        return this.policyHelperService.isMatchLinkable(match.type);
    }

    isMatchAnImage (match: any): boolean {
        return this.policyHelperService.isMatchAnImage(match.type);
    }

    loadMoreMatches (last: boolean, inview: boolean): void {
        if (last && inview) {
            this.matchLimit += 100;
        }
    }

    trackByIndex (index: number, item: any): any {
        return index;
    }
}
